export const Paths = {
  main: '/',
  about: '/about',
  brands: '/brands',
  events: '/events',
  news: '/news',
  unsubscribe: '/unsubscribe',
};
